/**
 * The Product analytics address's id lists, read leniently: an unreadable
 * value falls back on the default instead of breaking a shared link.
 */

/** Organization ids, comma-separated; `none` is an empty pick. */
export function pickedIds(raw: unknown): number[] | null {
  if (raw === "none") return [];
  const text = typeof raw === "number" ? String(raw) : typeof raw === "string" ? raw : "";
  const ids = text
    .split(",")
    .map(Number)
    .filter((id) => Number.isSafeInteger(id) && id > 0);
  return ids.length > 0 ? [...new Set(ids)] : null;
}

/** Type ids, comma-separated; `none` is an empty pick, anything else unreadable keeps all. */
export function typeIds(raw: unknown): string[] | null {
  if (raw === "none") return [];
  const words = typeof raw === "string" ? raw.split(",") : [];
  const ids = words.filter((word) => /^[a-z][a-z_]*$/.test(word));
  return ids.length > 0 ? [...new Set(ids)] : null;
}

/** One organization id, or the group for anything else. */
export function customerParam(raw: unknown): "group" | number {
  const value = typeof raw === "number" ? raw : typeof raw === "string" ? Number(raw) : NaN;
  return Number.isSafeInteger(value) && value > 0 ? value : "group";
}
